import React from 'react';
import ESIInclude from '../../esi';
import { HeaderWrapper } from '../components/header-wrapper/HeaderWrapper';
import { EnvVarsFeaturesContext } from './EnvVarsFeaturesContext';
import { UserContextProvider } from './UserContext';

export const HeaderApp = ({ initialState = {} }) => {
  const {
    envVars = {},
    features = {},
    categories = {},
    headerClientConfigQueryParameters = {},
    query = {},
    notificationBannerFolder = '',
    stickySearchHeader = '',
    isNavExperimentActive = '',
    mobileNavThumbnailsActive = '',
  } = initialState;

  return (
    <div>
      <ESIInclude
        id="experimentation-esi"
        src="/esi/experimentation/page-load-experiments?includeMonetateExperiences=true"
        data-testid="experimentation-esi"
      />
      <UserContextProvider>
        <EnvVarsFeaturesContext.Provider
          value={{
            envVars,
            features,
            categories,
            headerClientConfigQueryParameters,
            query,
            stickySearchHeader,
            isNavExperimentActive,
            mobileNavThumbnailsActive,
          }}
        >
          <HeaderWrapper features={features} />
          {notificationBannerFolder && (
            <ESIInclude
              id="header-notification-banner"
              src={`/${envVars.bannerPath}/${notificationBannerFolder}/index.html`}
              data-testid="header-notification-banner"
            />
          )}
        </EnvVarsFeaturesContext.Provider>
      </UserContextProvider>
    </div>
  );
};

HeaderApp.displayName = 'HeaderApp';
